import React, { useId } from 'react'
import * as S from './styled'
import {getSessionStorage} from "./../../utils/sessionStorage";

const Button = (props) => {
    const id = useId();

    const messageDatalayer = (props) => {
        try {
            window.top.postMessage({
                event: 'chatbot_interaction_link_button',
                action: props.displayName,
                link_url: props.value,
                bot_message: getSessionStorage("lastMessage"),
                bot_next_message: undefined
            }, document.referrer);
          } catch(e) {}
    }

    const IntentButton = () => {
        return <S.ActionButton id={"intent-button-"+id} data-testeid={"intent-button-"+id} onClick={()=>props.sendIntent(props)}>
           {props.displayName}
        </S.ActionButton>
    }
    const LinkButton = () => {
        return <S.ActionButton id={"link-button-"+id} data-testeid={"link-button-"+id}>
           <S.LinkButton
            href={props.value}
            target="_blank"
            onClick={()=>messageDatalayer(props)}
            >
                {props.displayName}
            </S.LinkButton>
        </S.ActionButton>
    }
    const BackButton = () => {
        return <S.BackButton id={"back-button-"+id} data-testeid={"back-button-"+id} onClick={()=>props.goBack(props)}>
           {props.displayName}
        </S.BackButton>
    }
    
    if (props.type == "intent") {
        return (
            <IntentButton />
        )
    }
    if (props.type == "link" ) {
        return (
            <LinkButton />
        )
    }
    if (props.type == "back" ) {
        return (
            <BackButton  />
        )
    }
}

export default Button
